// extracted by mini-css-extract-plugin
export default {"backgroundImage":"EK","content":"FK","rtbLeft":"GK","rtbRight":"HK","rtbLeftMobile":"IK","imageContainer":"JK","rtbBox":"KK","line":"LK","rtbDesktop":"MK"};
    if(module.hot) {
      // 1714442371201
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  